import React from 'react';
import { ColumnLayout as ColumnLayoutNPM, Column } from '@rotaryintl/component-column-layout';
import { Placeholder, RichText, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { formatAnnouncementDate } from '../../utilities/format-date-helper-function';

const AnnouncementSubLayout = (props) => {
  const title = props?.sitecoreContext?.route?.fields?.title;
  const bodyCopy = props?.sitecoreContext?.route?.fields?.bodyCopy;
  const author = props?.sitecoreContext?.route?.fields?.author;
  const publishDate = props?.sitecoreContext?.route?.fields?.publishDate;
  const language = props?.sitecoreContext?.language;

  return (
    <>
      <style>{`
        .rwc-col-layout {
          row-gap: 0px !important;
        }

        .rwc-col-layout__col > :not([hidden]) ~ :not([hidden]) {
          margin-top: 0px !important;
        }

        .rwc-col-layout__col--span-12-desktop {
          grid-column: span 12 / span 12;
          align-items: center;
        }

        .rwc-col-layout__title {
          margin-bottom: 16px !important;
          text-align: center;
          font-size: 38px !important;
          line-height: 45px !important;
          font-weight: 600 !important;
          word-wrap: break-word;
          overflow-wrap: break-word;
          hyphens: auto;
        }

        @media (min-width: 768px) {
          .rwc-col-layout__title {
            text-align: center;
            font-size: 48px !important;
            line-height: 57px !important;
            font-weight: 600 !important;
            margin-bottom: 16px !important;
          }
        }

        @media (min-width: 1024px) {
          .rwc-col-layout__title {
            text-align: center;
            font-size: 58px !important;
            line-height: 70px !important;
            font-weight: 600 !important;
            margin-bottom: 16px !important;
          }
        }

        .announcement-meta {
          margin-bottom: 16px;
          font-size: 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
        }

        .announcement-meta .author-wrapper {
          color: #717171;
          font-weight: 400;
        }

        .announcement-meta .author-name {
          font-weight: 700;
          color: #717171;
          line-height: 24px;
        }

        .announcement-meta .date {
          color: #717171;
          font-weight: 400;
          line-height: 24px;
        }

        @media (min-width: 768px) {
          .announcement-meta {
            max-width: 729px;
            margin-bottom: 16px ;
          }
        }

        @media (min-width: 1024px) {
          .announcement-meta {
            max-width: 858px;
            margin-bottom: 16px;
          }
        }

        .announcement-pull-image-container {
          overflow: visible;
        }

        @media (min-width: 768px) {
          .announcement-pull-image-container {
            max-width: 728px;
          }
        }

        @media (min-width: 1024px) {
          .announcement-pull-image-container {
            max-width: 858px;
          }
        }

        .announcement-pull-image-container .rotaryui-pull-image {
          margin-bottom: 24px;
        }

        .announcement-pull-image-container .rotaryui-pull-image figure {
          margin: 0;
          display: table !important;
          width: auto !important;
        }

        .announcement-pull-image-container .rotaryui-pull-image img {
          border-radius: 8px;
          display: block;
        }

        .announcement-pull-image-container .rotaryui-pull-image figcaption {
          display: table-caption;
          caption-side: bottom;
          word-wrap: break-word;
          overflow-wrap: break-word;
          font-size: 14px;
          color: #666;
          margin-top: 8px;
          line-height: 1.4;
        }

        @media (min-width: 769px) {
          .announcement-pull-image-container .rotaryui-pull-image.align-left {
            float: left;
            margin: 6px 24px 6px 0;
            clear: left;
            max-width: 50%;
          }

          .announcement-pull-image-container .rotaryui-pull-image.align-right {
            float: right;
            margin: 6px 0 6px 24px;
            clear: right;
            max-width: 50%;
          }

          .announcement-pull-image-container .rotaryui-pull-image.align-center {
            float: none;
            margin: 0 auto 24px;
            display: block;
            text-align: center;
            clear: both;
            max-width: 100%;
          }
        }

        @media (max-width: 768px) {
          .announcement-pull-image-container .rotaryui-pull-image {
            float: none !important;
            max-width: 100% !important;
            width: 100% !important;
            margin: 0 0 24px 0 !important;
            display: block;
          }

          .announcement-pull-image-container .rotaryui-pull-image figure {
            width: 100% !important;
          }

          .announcement-pull-image-container .rotaryui-pull-image img {
            width: 100%;
            height: auto;
          }
        }

        .announcement-body-copy p {
          margin-bottom: 16px;
          line-height: 1.6;
        }

        .announcement-body-copy h4 {
          margin-bottom: 16px;
          margin-top: 0;
          line-height: 1.5;
        }

        .announcement-body-copy ul,
        .announcement-body-copy ol {
          margin-bottom: 16px;
          padding-left: 1.5rem;
        }

        .announcement-body-copy ul { list-style-type: disc !important; }
        .announcement-body-copy ol { list-style-type: decimal !important; }
        .announcement-body-copy ul ul { list-style-type: circle !important; }
        .announcement-body-copy ul ul ul { list-style-type: square !important; }

        .announcement-body-copy li {
          display: list-item !important;
          list-style: inherit !important;
          margin-bottom: 4px;
          line-height: 1.6;
        }

        .announcement-body-copy a {
          color: #0056a3;
          text-decoration: none;
        }

        .announcement-body-copy a:hover,
        .announcement-body-copy a:focus {
          color: #003d75;
          box-shadow: inset 0 -1px currentColor;
        }

        .announcement-pull-image-container .rotaryui-divider {
          display: none;
        }

        .announcement-pull-image-container::after {
          content: "";
          display: table;
          clear: both;
        }

        .announcement-pull-image-container > div {
          overflow: visible;
        }
      `}</style>

      <ColumnLayoutNPM title={<Text field={title} />} titleAlign="center">
        <Column span="12" spanTablet="12" spanDesktop="12">
          {(author || publishDate) && (
            <div className="announcement-meta">
              {author && author.value && (
                <span className="author-wrapper">
                  by{' '}
                  <span className="author-name">
                    <Text field={author} />
                  </span>
                </span>
              )}
              {publishDate && <span className="date">{formatAnnouncementDate(publishDate, language)}</span>}
            </div>
          )}

          <div className="announcement-pull-image-container">
            <Placeholder name="columnlayout-main" rendering={props.rendering} />
            <div className="announcement-body-copy">
              <RichText field={bodyCopy} />
            </div>
          </div>
        </Column>
      </ColumnLayoutNPM>

      <Placeholder name="rotary-fullwidthsublayout" rendering={props.rendering} />
    </>
  );
};

export default withSitecoreContext()(AnnouncementSubLayout);
